import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@style/base.styl'

Vue.config.productionTip = false

router.afterEach((to, from) => {
  // 动态修改标题
  document.title = to.meta.title || ' '
})

// window.WeixinJSBridge = {
//   invoke(a, b, c) {
//     c({
//       err_msg: 'get_brand_wcpay_request:ok'
//     })
//   }
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
